import { render, staticRenderFns } from "./JobBoardManagement.vue?vue&type=template&id=102280f6&scoped=true&"
import script from "./JobBoardManagement.vue?vue&type=script&lang=ts&"
export * from "./JobBoardManagement.vue?vue&type=script&lang=ts&"
import style0 from "./JobBoardManagement.vue?vue&type=style&index=0&id=102280f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102280f6",
  null
  
)

export default component.exports